import React, { PureComponent } from 'react';
import { LoadingIndicator } from '../../atoms/LoadingIndicator';
import { ContentListItem } from '../../molecules/ContentListItem';
import { ContentTypeKeys } from '../../molecules/ContentListSelector';
import { Container, Message, LoadingWrapper } from './elements';
import { Purchase } from '../../../domain/entities';

export type ContentPreview = {
  id: string;
  title: string;
  description: string;
  points: number;
  thumbnailURL: string;
  tags: {
    showOnMyPage: boolean;
    primeContent: boolean;
    eliteContent: boolean;
    regularContent: boolean;
  };
  isRestricted: boolean;
};

type Props = {
  contents: Array<ContentPreview>;
  userId: string;
  purchases: { [key: string]: Purchase };
  contentType: ContentTypeKeys;
  modalShowing?: boolean;
  selectedContentId?: string;
  isFetchingVideoByIdFromContent: boolean;
  isFetchingProjectContentById: boolean;
  isFetchingEAById: boolean;
  isFetchingPurchases: boolean;
  isFetchingUser: boolean;
  onPressPurchase: (id: string) => void;
  navigateToManualContentViewer: (manualId: string) => void;
} & Partial<DefaultProps>;
type DefaultProps = Readonly<typeof defaultProps>;

const defaultProps = {
  isFetchingVideos: false as boolean,
  isFetchingProjectsContents: false as boolean,
  isFetchingEAPrograms: false as boolean,
};

export default class ContentList extends PureComponent<Props & DefaultProps> {
  static defaultProps = defaultProps;

  handleOnPressPurchase = (id: string) => {
    const { onPressPurchase } = this.props;
    onPressPurchase(id);
  };

  getIsFetching = (): { [key in ContentTypeKeys]: boolean } => {
    const {
      isFetchingVideos,
      isFetchingProjectsContents,
      isFetchingEAPrograms,
    } = this.props;

    return {
      pastVideos: isFetchingVideos,
      pastProjectVideo: isFetchingProjectsContents,
      eaProgram: isFetchingEAPrograms,
    };
  };

  render = (): React.ReactElement => {
    const {
      contents,
      purchases,
      userId,
      contentType,
      navigateToManualContentViewer,
      modalShowing,
      selectedContentId,
      isFetchingVideoByIdFromContent,
      isFetchingProjectContentById,
      isFetchingEAById,
      isFetchingPurchases,
      isFetchingUser,
    } = this.props;
    const isFetchingContentTypeMap = this.getIsFetching();

    return (
      <Container className="content-list" modalShowing={modalShowing || false}>
        {isFetchingContentTypeMap[contentType] ? (
          <LoadingWrapper>
            <LoadingIndicator />
          </LoadingWrapper>
        ) : contents && contents.length > 0 ? (
          contents.map(({ id, ...content }) => (
            <ContentListItem
              {...content}
              key={id}
              id={id}
              buttonTheme={
                purchases && purchases[`${userId}_${id}`]
                  ? 'inverse'
                  : 'primary'
              }
              onPressPurchase={() => this.handleOnPressPurchase(id)}
              navigateToManualContentViewer={navigateToManualContentViewer}
              isFetchingVideoByIdFromContent={
                id === selectedContentId && isFetchingVideoByIdFromContent
              }
              isFetchingProjectContentById={
                id === selectedContentId && isFetchingProjectContentById
              }
              isFetchingEAById={id === selectedContentId && isFetchingEAById}
              contentType={contentType}
              isFetchingPurchases={
                id === selectedContentId && isFetchingPurchases
              }
              isFetchingUser={id === selectedContentId && isFetchingUser}
            />
          ))
        ) : (
          <Message>現在、ご利用可能なコンテンツはございません。</Message>
        )}
      </Container>
    );
  };
}
